/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ThumbDownOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Thumb Down Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25.458 6ZM32.554 19.7 28.57 8.424A4.636 4.636 0 0 0 24.444 6H10a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.476c2.545 1.174 7.177 4.83 7.64 9.312A3.327 3.327 0 0 0 20.921 34c1.626 0 3.1-1.814 3.173-3.937a21.477 21.477 0 0 0-.8-6.081l6.55.01a3 3 0 0 0 2.71-4.292ZM29.847 22h-9.5a15.051 15.051 0 0 1 1.746 8.063c-.052 1.2-.563 1.932-1.173 1.937a1.374 1.374 0 0 1-1.281-1.2c-.49-5.873-6.773-10.245-9.64-11.4V8l14.991-.02a1.842 1.842 0 0 1 1.742 1.232l4.017 11.356A1 1 0 0 1 29.847 22Z"
    />
  </svg>`;
};
